/**
 * Build props shared by all node types (milestone, decision, task).
 */
export default function buildCommonProps({
  task,
  position,
  layoutSurfaceEpoch,
  selectedNodes,
  draggingNode,
  connectingFrom,
  isConnecting,
  connectingTarget,
  focusedTaskIds,
  isFocusMode,
  isAnimatingLayout,
  isSliding,
  isFadingOut,
  isFadingIn,
  dropTarget,
  hoveredMissionId,
  zoom,
  handlers,
  isQuickViewEnabled,
  onMissionHover,
  onMissionLeave,
  onRenameTask,
  handleDimensionsChange,
}) {
  return {
    task,
    position,
    layoutSurfaceEpoch,
    isSelected: selectedNodes.has(task.id),
    isDragging: draggingNode === task.id,
    isConnecting: connectingFrom === task.id,
    isConnectionTarget: isConnecting && connectingFrom !== task.id,
    isConnectionHovered: connectingTarget === task.id,
    isFocusedMain: focusedTaskIds?.has(task.id),
    isFocusDependency: isFocusMode && !focusedTaskIds?.has(task.id),
    isAnimating: isAnimatingLayout || isSliding,
    isFadingOut,
    isFadingIn,
    isDropTarget: dropTarget?.id === task.id,
    isHoveredFromHUD: hoveredMissionId === task.id,
    zoom,
    onMouseDown: handlers.onMouseDown,
    onClick: handlers.onClick,
    onConnectionDragStart: handlers.onConnectionDragStart,
    onRename: onRenameTask,
    onDimensionsChange: handleDimensionsChange,
    onQuickViewMouseEnter: isQuickViewEnabled ? handlers.onQuickViewMouseEnter : undefined,
    onQuickViewMouseLeave: isQuickViewEnabled ? handlers.onQuickViewMouseLeave : undefined,
    onQuickViewMouseMove: isQuickViewEnabled ? handlers.onQuickViewMouseMove : undefined,
    onNodeHoverForHUD: () => onMissionHover?.(task.id),
    onNodeLeaveForHUD: () => onMissionLeave?.(),
  };
}
